import type { CasinoBet, CasinoBetStatusKey } from "../types/bets";

type CasinoBetLike = Pick<CasinoBet, "bet_id" | "title" | "transactions"> & {
  [key: string]: unknown;
};

const getTransactionIdByTitle = (
  record: CasinoBetLike | null | undefined,
  titles: string[],
): string | null =>
  record?.transactions?.find((transaction) =>
    titles.includes(transaction?.title),
  )?.transaction_id ?? null;

export const getPlacementTransactionId = (
  record: CasinoBetLike | null | undefined,
): string | null =>
  getTransactionIdByTitle(record, ["bet_placement"]) ??
  record?.bet_id ??
  null;

export const getSettlementTransactionId = (
  record: CasinoBetLike | null | undefined,
): string | null => getTransactionIdByTitle(record, ["bet_won", "bet_lose"]);

export const deriveCasinoBetStatus = (
  record: { title?: string | null } | null | undefined,
): CasinoBetStatusKey => {
  if (record?.title === "bet_won") return "bet_won";
  if (record?.title === "bet_lose") return "bet_lose";
  if (record?.title === "win_rollback") return "bet_rollback";
  return "bet_placement";
};

export const isCasinoBetSettled = (
  record: { title?: string | null } | null | undefined,
): boolean =>
  record?.title === "bet_won" || record?.title === "bet_lose";
